/*
 * Module for the Benefit Worksheet Link control
*/

rs.module("ui/controls/content/benefitworksheetlink",

    [],

    function () {

        //
        // Initialize
        //
        function initialize(jsSelectors) {

            // hide popup once a fas option is clicked
            $.js(jsSelectors.fasLink, { multiple: true }).click(function () {
                $.js(jsSelectors.fasPopup).modal('hide');
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);